module.exports = __webpack_public_path__ + "img/2024-17.3d2d783a.jpg";